import { render, staticRenderFns } from "./TeacherRelations.vue?vue&type=template&id=9c9780d6&"
import script from "./TeacherRelations.vue?vue&type=script&lang=js&"
export * from "./TeacherRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports